import React from 'react';

export default function PlusIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.5 9.5" preserveAspectRatio="xMidYMid meet"><path d="M8.8 4H5.5V.8c0-.5-.3-.8-.7-.8S4 .3 4 .8V4H.8c-.5 0-.8.3-.8.8s.3.8.8.8H4v3.2c0 .4.3.8.8.8s.8-.3.8-.8V5.5h3.2c.4 0 .8-.3.8-.8S9.2 4 8.8 4z"/></svg>
	);
}
